import React, { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "../context/AuthContext";
import {
  ThumbUp,
  ThumbDown
} from "@mui/icons-material";
import {
  getStat,
  getStatUser,
  saveReaction
} from '../services/apiService';

const LikeDislike = ({ contentId, userParamId }) => {
  const { user_session } = useAuth();
  const [likes, setLikes] = useState(0);
  const [dislikes, setDislikes] = useState(0);
  const [userReaction, setUserReaction] = useState(null);
  const [loading, setLoading] = useState(false);

  // 🔹 Charger stats + réaction utilisateur
  const fetchData = async () => {
    try {
        
        const statsRes = await getStat(contentId); 
        const userRes = await getStatUser(contentId, userParamId); 

        console.log(statsRes);
        
        setLikes(statsRes.likes || 0);
        setDislikes(statsRes.dislikes || 0);
        setUserReaction(userRes.type || null);
    } catch (err) {
      console.error("Erreur fetch reactions:", err);
    }
  };

  // 🔹 Réagir (like/dislike)
  const handleReaction = async (type) => {
    if (!userParamId) return alert("Veuillez vous connecter.");
    setLoading(true);
    try {
      await saveReaction({
        contentId:contentId,
        type:type,
        userId:userParamId
      });
      await fetchData();
    } catch (err) {
      console.error("Erreur reaction:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (contentId) fetchData();
  }, [contentId]);

  return (
    <div className="flex items-center gap-4 mt-3 views">
      <button
        onClick={() => handleReaction("like")}
        disabled={loading}
        className={`flex items-center gap-1 px-3 py-1 rounded-full border transition like-btn ${
          userReaction === "like"
            ? "likedis-btn"
            : "bg-gray-100 text-gray-700 hover:bg-gray-200"
        }`}
      >
        <ThumbUp className="w-5 h-5" />
        <span>{likes}</span>
      </button>

      <button
        onClick={() => handleReaction("dislike")}
        disabled={loading}
        className={`flex items-center gap-1 px-3 py-1 rounded-full border transition dislike-btn ${
          userReaction === "dislike"
            ? "likedis-btn"
            : "bg-gray-100 text-gray-700 hover:bg-gray-200"
        }`}
      >
        <ThumbDown className="w-5 h-5" />
        <span>{dislikes}</span>
      </button>
    </div>
  );
};

export default LikeDislike;
